(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["trailmods-fitment-checker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fitment-checker')) {
    class FitmentChecker extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.yearSelect = this.querySelector('[name="fitment-year"]');
        this.modelSelect = this.querySelector('[name="fitment-model"]');
        this.results = this.querySelectorAll('[data-fitment-result]');

        try {
          this.messages = JSON.parse(this.querySelector('[data-fitment-messages]').content.textContent);
        } catch (e) {
          this.messages = { success: '', error: '', warning: '' };
        }

        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.check();

          // The theme's custom-button enters a loading state on submit and only
          // resets on navigation; since this form never navigates, reset it here.
          const submitButton = this.form.querySelector('button[type="submit"]');

          if (submitButton) {
            setTimeout(() => submitButton.removeAttribute('aria-busy'), 600);
          }
        });

        this.restore();
      }

      check() {
        const year = this.yearSelect.value;
        const model = this.modelSelect.value;

        if (!year || !model) {
          this.show('warning', year, model);
          return;
        }

        const option = this.modelSelect.options[this.modelSelect.selectedIndex];
        const modelFits = option.getAttribute('data-fits') !== 'false';
        const yearFits = Number(year) >= Number(this.dataset.yearMin) && Number(year) <= Number(this.dataset.yearMax);
        const fits = modelFits && yearFits;

        this.show(fits ? 'success' : 'error', year, model);

        const detail = { year: year, model: model, fits: fits };

        // Klaviyo tracking — queue until Klaviyo.js is ready
        window.klaviyo = window.klaviyo || [];
        window.klaviyo.push(['track', 'Checked Fit', {
          'Result': fits ? 'compatible' : 'not compatible',
          'Year': year,
          'Model': model
        }]);

        if (window.TrailModsFitment) {
          if (fits) {
            window.TrailModsFitment.write(detail);
          } else {
            window.TrailModsFitment.clear();
          }

          return;
        }

        try {
          if (fits) {
            localStorage.setItem('trailmods:fitment', JSON.stringify(detail));
          } else {
            localStorage.removeItem('trailmods:fitment');
            document.cookie = 'trailmods_fitment=; path=/; max-age=0; SameSite=Lax';
          }

          document.dispatchEvent(new CustomEvent('trailmods:fitment-change', { detail: fits ? detail : null }));
        } catch (e) {
        }
      }

      show(status, year, model) {
        this.results.forEach((result) => {
          const active = result.getAttribute('data-fitment-result') === status;
          result.hidden = !active;

          if (active) {
            const message = (this.messages[status] || '')
              .replace('{year}', year || '')
              .replace('{model}', model || '');
            result.querySelector('[data-fitment-message]').textContent = message;
          }
        });
      }

      restore() {
        let saved;

        if (window.TrailModsFitment) {
          saved = window.TrailModsFitment.read();
        } else {
          try {
            saved = JSON.parse(localStorage.getItem('trailmods:fitment'));
          } catch (e) {
            return;
          }
        }

        if (!saved || !saved.year || !saved.model) {
          return;
        }

        if (this.yearSelect.querySelector('option[value="' + saved.year + '"]')) {
          this.yearSelect.value = saved.year;
        }

        const modelOption = Array.from(this.modelSelect.options).find((option) => option.value === saved.model);

        if (modelOption) {
          this.modelSelect.value = saved.model;
        }
      }
    }

    customElements.define('fitment-checker', FitmentChecker);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trailmods-video-with-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-trailmods-vwt-fullscreen]');

    if (!button) {
      return;
    }

    const card = button.closest('.trailmods-vwt__video-card');
    const media = card && card.querySelector('video-media');

    if (!card || !media) {
      return;
    }

    if (!media.hasAttribute('loaded')) {
      media.click();
    }

    const video = media.querySelector('video');
    const iframe = media.querySelector('iframe');
    let fullscreenTarget = iframe || video || card;
    let requestFullscreen = fullscreenTarget.requestFullscreen || fullscreenTarget.webkitRequestFullscreen;

    if (!requestFullscreen) {
      fullscreenTarget = card;
      requestFullscreen = card.requestFullscreen || card.webkitRequestFullscreen;
    }

    if (video && video.paused) {
      video.play().catch(() => {});
    }

    if (video && video.webkitEnterFullscreen && !document.fullscreenEnabled && !document.webkitFullscreenEnabled) {
      video.webkitEnterFullscreen();
      return;
    }

    if (requestFullscreen) {
      const request = requestFullscreen.call(fullscreenTarget);

      if (request && request.catch) {
        request.catch(() => {});
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
